import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import { Location } from '@angular/common';

/**
 * Activation guard to protect against the login page triggering the normal Angular routes.
 */
@Injectable()
export class LoginPageActivateGuard implements CanActivate {
  constructor(private location: Location, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (location.pathname === "/login" || location.pathname.startsWith('/2FA')) { // } && location.hash == "#/Portal") {
      this.router.navigateByUrl("/?_redirect=" + encodeURIComponent(location.hash));
      return false;
    }
    return true;
  }
}
